/* src/app/components/header/header.component.scss */
#title {
  color: #fff;
  font-size: 22px;
}
@media (min-width: 1000px) {
  #title {
    text-align: center;
    width: 101%;
  }
}
#menu-color {
  color: #fff;
}
#buttons-group {
  display: flex;
  align-items: center;
  margin: 0px 13px;
}
#header {
  --background: #0e3d5b;
  padding: 0;
}
/*# sourceMappingURL=header.component.css.map */
